window.addEventListener("load", function () {
  let scrollThumbs = document.querySelector('#thumb-scroll');

  ///////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////

  let galleryImages = document.querySelectorAll('.gallery li ');
  let gallerySize = galleryImages.length;
  let galleryHeight = 0;
  let galleryPoints = new Array();
  let galleryCounter = 0;

  let thumbImages = document.querySelectorAll('#thumb-scroll ul li');
  let thumbSize = thumbImages.length;

  if(gallerySize > 3){
    galleryImages.forEach(function(item, i){
      let current = item.offsetHeight;
      let trueCurrent = current ;
      galleryCounter = galleryCounter + trueCurrent;
      galleryPoints.push(galleryCounter);
    });

    //console.log(galleryPoints); 
  }

  let scrollBox = document.querySelector("#thumb-scroll");
  scrollBox.addEventListener('scroll', function(){
    let scrollPos = scrollBox.scrollTop;

    let thumbPoints = new Array();
    let thumbCounter = 0;

    thumbImages.forEach(function(item, i){
      let current = item.offsetHeight;
      let trueCurrent = current;

      thumbCounter = thumbCounter + trueCurrent;
      thumbPoints.push(thumbCounter);
    });

    let firstPoint = thumbPoints[0];
    let lastPoint = thumbPoints[thumbPoints.length - 1];

    if(scrollPos > 0){
      document.querySelector('#thumb-up').classList.add('appear');
      document.querySelector('#thumb-down').classList.add('appear');
    }

    if(scrollPos > 0){
      document.querySelector('#thumb-up').classList.add('appear');
      document.querySelector('#thumb-down').classList.add('appear');
    }

    if( scrollBox.scrollTop === (scrollBox.scrollHeight - scrollBox.offsetHeight)){
      document.querySelector('#thumb-down').classList.remove('appear');
    }

    if(scrollPos == 0){
      document.querySelector('#thumb-up').classList.remove('appear');
    }

  });

  let halfPoint = galleryPoints[0] / 3;
  let midPoint = galleryPoints[1] - halfPoint;

  window.addEventListener('scroll', function(){
    let scrollPos = window.scrollY;

    //console.log(scrollPos);

    if(scrollPos > midPoint){
      scrollThumbs.scrollTop = scrollThumbs.scrollTop + 300;
      document.querySelector('#thumb-down').classList.remove('appear');
      document.querySelector('#thumb-up').classList.add('appear');
    } else if(scrollPos < galleryPoints[2]) {
      scrollThumbs.scrollTop = scrollThumbs.scrollTop - 300;
      document.querySelector('#thumb-up').classList.remove('appear');
      document.querySelector('#thumb-down').classList.add('appear');
    }
  });

  let scrollPos = window.scrollY;

 //console.log(scrollPos);

  if(scrollPos > galleryPoints[1]){
    scrollThumbs.scrollTop = scrollThumbs.scrollTop + 300;
    document.querySelector('#thumb-down').classList.remove('appear');
    document.querySelector('#thumb-up').classList.add('appear');
  } else if(scrollPos < galleryPoints[2]) {
    scrollThumbs.scrollTop = scrollThumbs.scrollTop - 300;
    document.querySelector('#thumb-up').classList.remove('appear');
    document.querySelector('#thumb-down').classList.add('appear');
  }

});
//console.log("Magic Scroll Point = " + midPoint);


///////////////////////////////////////////////////////
///////////////////////////////////////////////////////
///////////////////////////////////////////////////////

window.addEventListener("load", function () {
  let upArrow = document.querySelector('#thumb-up');
  let downArrow = document.querySelector('#thumb-down');

  if(upArrow){
    upArrow.addEventListener('click', function(event){
      event.preventDefault();
      //console.log("Scroll Up");
      document.querySelector('#thumb-up').classList.remove('appear');
      document.querySelector('#thumb-down').classList.add('appear');
      scrollThumbs.scrollTop = scrollThumbs.scrollTop - 300;
      window.scrollTo(0, 0);
    });
  }

  if(downArrow){
    downArrow.addEventListener('click', function(event){
      event.preventDefault();
      //console.log("Scroll Down");
      document.querySelector('#thumb-down').classList.remove('appear');
      document.querySelector('#thumb-up').classList.add('appear');
      scrollThumbs.scrollTop = scrollThumbs.scrollTop + 300;
    });
  }
});